import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatTabChangeEvent } from "@angular/material/tabs";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ErrorType } from "src/app/enums/error-type.enum";
import endpoints from "src/app/helpers/endpoints";
import { ApiService } from "src/app/services/api.service";
import { CommonService } from "src/app/services/common.service";
import { ClaimService } from "../../services/claim.service";
import { UpdateClaimNoteModalComponent } from "../update-claim-note-modal/update-claim-note-modal.component";

@Component({
  selector: "fury-claim-notes",
  templateUrl: "./claim-notes.component.html",
  styleUrls: ["./claim-notes.component.scss"],
})
export class ClaimNotesComponent implements OnInit, OnDestroy {
  ngUnsubscribe = new Subject<void>();
  selectConfig = { disableOptionCentering: true, panelClass: "custom-class" };
  columns = [
    "status",
    "assigned",
    "fileClaimNumber",
    "createdOn",
    "createdBy",
    "priority",
    "notes",
    "actions",
  ];
  tabNameList = {
    all: "All",
    new: "New",
    assigned: "Assigned",
    closed: "Closed",
  };
  dataSource = [];
  pageIndex = 0;
  pageSize = 5;
  totalCount = 0;
  tabName = this.tabNameList.all;
  constructor(
    public dialogRef: MatDialogRef<ClaimNotesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {fileClaimId: string, fileClaimNumber: string},
    private apiService: ApiService,
    public commonService: CommonService,
    private claimService: ClaimService,
    private dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.fetchClaimNotes();
    this.shouldFetchClaimNote();
  }
  shouldFetchClaimNote(){
    this.claimService.shouldViewFetchAgreement$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: boolean) => {
      if(res) this.fetchClaimNotes();
    });
  }
  close() {
    this.dialogRef.close();
  }
  onTabChange(event: MatTabChangeEvent) {
    this.pageIndex = 0;
    this.tabName = this.tabNameList[event.tab?.textLabel.toLowerCase()];
    this.fetchClaimNotes();
  }
  pageSizeChange(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.fetchClaimNotes();
  }
  fetchClaimNotes() {
    this.apiService
      .get(`${endpoints.fileAClaim.fetchClaimNotes(this.data.fileClaimId)}?page=${this.pageIndex + 1}&size=${this.pageSize}&tabName=${this.tabName}`)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.body) {
            this.dataSource = res.body?.notes?.data;
            this.totalCount = res.body?.notes?.total;
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.error.message, ErrorType.Error);
        },
      });
  }
  handleNotes(type: string, rowData?: any) {
    this.dialog
      .open(UpdateClaimNoteModalComponent, {
        width: "800px",
        panelClass: "payment-info",
        data: { type, rowData, fileClaimId: this.data.fileClaimId, fileClaimNumber: this.data.fileClaimNumber },
      })
      .afterClosed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        if (res) {
        this.claimService.setFetchClaimNote(true);
        }
      });
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
